import { render, staticRenderFns } from "./ThingsToNote3.vue?vue&type=template&id=0b3be0a8&"
import script from "./ThingsToNote3.vue?vue&type=script&lang=js&"
export * from "./ThingsToNote3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports